import Seo from "@/components/Seo";
import PageHeader from "@/components/PageHeader";
import { Reveal, Overline } from "@/components/bits";
import { CONTACT } from "@/lib/site";

export default function Bedriftsbehandling() {
  return (
    <>
      <Seo
        title="Bedriftsbehandling | Actus Osteopati – Osteopat Oslo sentrum"
        description="Osteopatibehandling for bedrifter og arbeidsplasser i Oslo. Actus Osteopati tilbyr behandling av muskel- og skjelettplager for ansatte."
      />
      <PageHeader
        overline="For bedrifter"
        title="Bedriftsbehandling"
        testId="bedriftsbehandling-heading"
      />

      <section data-testid="bedrift-content" className="bg-paper py-24 md:py-32">
        <div className="max-w-7xl mx-auto px-6 md:px-12">
          <Reveal className="text-center max-w-2xl mx-auto">
            <Overline>Tilbud til arbeidsplasser</Overline>
            <h2 className="font-display font-light text-3xl md:text-4xl leading-tight">
              Behandling på arbeidsplassen
            </h2>
            <p className="mt-8 text-base md:text-lg leading-relaxed text-ink-soft">
              Vi tilbyr bedriftsbehandling på arbeidsplassen, hvor våre
              osteopater kommer ut til bedriften og behandler de ansatte. Dette
              gjør det enkelt for medarbeiderne å få behandling i løpet av
              arbeidsdagen, uten unødvendig reisetid.
            </p>
            <p className="mt-5 text-base md:text-lg leading-relaxed text-ink-soft">
              Et behandlingstilbud på arbeidsplassen kan bidra til å forebygge
              og redusere muskel- og skjelettplager, øke bevisstheten rundt egen
              helse og gjøre det enklere for ansatte å ivareta kroppen i en
              travel arbeidshverdag. For bedriften kan dette være et verdifullt
              tiltak for et godt arbeidsmiljø og medarbeidernes helse og
              trivsel.
            </p>
            <p className="mt-5 text-base md:text-lg leading-relaxed text-ink-soft">
              Ønsker dere å høre mer om hvordan vi kan tilrettelegge et tilbud
              for deres bedrift? Ta kontakt med oss på{" "}
              <a
                data-testid="bedrift-email-link"
                href={`mailto:${CONTACT.email}`}
                className="underline underline-offset-4 decoration-ink/30 hover:decoration-ink transition-colors duration-300"
              >
                {CONTACT.email}
              </a>
              .
            </p>
          </Reveal>

        </div>
      </section>
    </>
  );
}
